import {http} from './http'
import {publicConfig} from './public-config'
const BATCH_SIZE = 10;
const BATCH_TIMEOUT = 5000;

class ClientLogger {
    constructor(enabled = true) {
        this.queue = [];
        this.batchTimeout = null;
        this.enabled = enabled;
    }

    _send(level, message, context = null) {
        if (!this.enabled) return;

        const logEntry = {
            level,
            message,
            context,
            timestamp: Date.now(),
            url: window.location.href,
            userAgent: navigator.userAgent
        };

        this.queue.push(logEntry);

        if (this.queue.length >= BATCH_SIZE) {
            this._flush();
        } else if (!this.batchTimeout) {
            this.batchTimeout = setTimeout(() => this._flush(), BATCH_TIMEOUT);
        }
    }

    _flush() {
        if (this.queue.length === 0) return;

        const batch = [...this.queue];
        this.queue = [];

        if (this.batchTimeout) {
            clearTimeout(this.batchTimeout);
            this.batchTimeout = null;
        }

        batch.forEach(logEntry => {
            http.post('/api/v1/public/log', logEntry).catch(err => {
                console.error('Failed to send log to server:', err);
            });
        });
    }

    log(message, context = null) {
        console.log(message, context);
        this._send('log', message, context);
    }

    info(message, context = null) {
        console.info(message, context);
        this._send('info', message, context);
    }

    warn(message, context = null) {
        console.warn(message, context);
        this._send('warn', message, context);
    }

    error(message, context = null) {
        console.error(message, context);
        this._send('error', message, context);
    }

    enable = async () => {
        const request = this.enableRequest = {};
        const config = await publicConfig.getConfig().catch(() => null);
        if (this.enableRequest === request) this.enabled = config?.debug?.clientLoggerEnabled === true;
    }

    disable() {
        this.enableRequest = null;
        this.enabled = false;
        this._flush();
    }

    flush() {
        this._flush();
    }
}

export const clientLogger = new ClientLogger(false);

window.addEventListener('error', (event) => {
    clientLogger.error('Uncaught Error', {
        message: event.message,
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
        stack: event.error?.stack
    });
});

window.addEventListener('unhandledrejection', (event) => {
    clientLogger.error('Unhandled Promise Rejection', {
        reason: event.reason?.toString(),
        stack: event.reason?.stack
    });
});

window.addEventListener('beforeunload', () => {
    clientLogger.flush();
});
